import React from 'react';
import PropTypes from 'prop-types';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

export default function PanelHeader({ icon, title, subtitle, infoLink, tooltipLink }) {
  return (
    <Card.Header className="d-flex align-items-center gap-3 p-4">
      <FontAwesomeIcon className="text-primary" icon={icon} size="2x" />
      <div className="flex-grow-1">
        <p className="fs-large mb-0">
          {title}
          {infoLink && (
            <OverlayTrigger
              overlay={<Tooltip id="info-link-tooltip">{tooltipLink || 'View more information'}</Tooltip>}
              placement="top"
            >
              <a
                className="ms-2"
                href={infoLink}
                rel="noopener noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon className="text-primary" icon={faInfoCircle} size="sm" />
              </a>
            </OverlayTrigger>
          )}
        </p>
        <small>{subtitle}</small>
      </div>
    </Card.Header>
  );
}

PanelHeader.propTypes = {
  icon: PropTypes.object.isRequired,
  infoLink: PropTypes.string,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tooltipLink: PropTypes.string
};
